export default ($axios) => ({
    $axios,

    async fetch(request) {
        return await $axios.get(`${request}`)
    },

    async fetchList(query) {
        return await $axios.get(`/requests/list${query}`)
    },

    async fetchRequests(query) {
        return await $axios.get(`landing/requests${query}`)
    },

    async fetchWeekRequests(form) {
        return await $axios.get('/masters/weekly-calendar', {
            params: form,
        })
    },
    // weekRequests

    async fetchById(id) {
        return await $axios.get(`/requests/${id}`)
    },

    async fetchClientRequests(id) {
        return await $axios.get(`/requests/by-client/${id}`)
    },

    async fetchMasterRequests(id, page) {
        return await $axios.get(`/requests/by-master/${id}?page=${page}`)
    },

    async removeRequest(id) {
        return await $axios.delete(`/landing/requests/${id}`)
    },

    async rejectOrder(id, form) {
        return await $axios.post(`requests/${id}/cancel`, form)
    },

    async statuses() {
        return await $axios.get('/requests/statuses')
    },

    async updateService(id, form) {
        return await $axios.post(`/requests/${id}/service`, form)
    },

    async makePaid(id) {
        return await $axios.post(`/requests/${id}/paid`)
    },

    async create(form) {
        return await $axios.post('/requests', form)
    },

    async addMediaToOrders(id, media) {
        return await $axios.post(`/requests/${id}/media`, media)
    },

    async update(id, form) {
        return await $axios.put(`/requests/${id}`, form)
    },

    async updateStatus(id, form) {
        return await $axios.post(`/requests/${id}/status`, form)
    },

    async updateComment(id, form) {
        return await $axios.put(`/requests/${id}/comment`, form)
    },

    async addTags(id, form) {
        return await $axios.post(`/requests/${id}/work_tag`, form)
    },

    async addMaterials(id, form) {
        return await $axios.post(`/requests/${id}/materials`, form)
    },

    async sendbill(id) {
        return await $axios.post(`/requests/${id}/bill`)
    },

    async sendSms(id, form) {
        return await $axios.post(`/requests/${id}/sms`, form)
    },

    async remove(id) {
        return await $axios.delete(`/requests/${id}`)
    },

    async fetchExtraPrices({
        date,
        service_id,
        office_id,
    }) {
        const office = office_id ? `&office_id=${office_id}` : ''
        return await $axios.get(
            `/extra-prices?service_id=${service_id}${office}&date=${date}`,
        )
    },

    async fetchMinMaxPrice() {
        return await $axios.get('/requests/prices')
    },

    async generatePdf(params) {
        return await $axios.get(`/requests/export${params}`, {
            responseType: 'blob',
        })
    },

    async fetchAvailableDays({
        service_id,
        office_id,
        duration,
    }) {
        return await $axios.get(`/available-days?service_id=${service_id}&office_id=${office_id}&duration=${duration}`)
    },
})
